import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { Button, Modal } from "react-bootstrap";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import {
  changeStatus,
  userListing,
  userListingDownload,
  verifyUser,
  workerVerification,
  workerVerificationdownload,
} from "../Redux/Actions/adminAction";
import Pagination from "../Components/Layout/Pagination";
import Search from "../Components/Layout/Search";
import { toast } from "react-toastify";
import logo from "../Assets/Images/placeholder 1 .png";

export default function WorkersVerification() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.usermgmtData.workerDetails);

  const BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

  const [page, setpage] = useState("1");
  const [search, setsearch] = useState("");
  const [limit, setlimit] = useState("10");
  const [flag, setflag] = useState(true);
  const [pageType, setPageType] = useState("");

   const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");

  useEffect(() => {
    dispatch(workerVerification({ page, search, limit, type: 0 }));
  }, [page, search, limit, flag]);

  // const handlechange = (e) => {
  //   console.log(e.target.value);
  //   setPageType(e.target.value);

  //   dispatch(userListing({ page, search, limit, type: e.target.value }));
  // };

  const fetchDataAndExportToExcel = useCallback(async () => {
    try {
      const response = await dispatch(workerVerificationdownload({ type: 0 }));
      console.log(response);

      const allData = response?.payload?.data?.users;

      const ws = XLSX.utils.json_to_sheet(allData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      XLSX.writeFile(wb, "exported_data.xlsx", {
        bookType: "xlsx",
        bookSST: false,
        type: "blob",
      });
    } catch (error) {
      console.error("Error fetching or exporting data:", error);
    }
  }, [dispatch]);

    const handleVerifyAction = () => {
    dispatch(verifyUser({ userId: selectedUserId, type: selectedAction })).then(
      (res) => {
        if (res?.payload?.success) {
          toast.success(res?.payload?.message);
          setflag(!flag);
        } else {
          toast.error(res?.payload?.message);
        }
        setShowModal(false);
        setSelectedUserId(null);
        setSelectedAction("");
      }
    );
  };


  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>Workers Verification</h2>
        </div>
        <hr />
        <Container fluid>
          <div className="cmn-top-fields">
            <Row>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Group>
                  <Search setsearch={setsearch} />
                </Form.Group>
              </Col>
              {/* <Col xxl={2} xl={3} lg={4} md={4}>
                <Form.Select aria-label="Default select example">
                  <option>Action</option>
                  <option value="1">24</option>
                  <option value="2">25</option>
                  <option value="3">26</option>
                </Form.Select>
              </Col> */}
              <Col
                xxl={9}
                xl={9}
                lg={8}
                md={8}
                className="d-flex justify-content-end align-items-center"
              >
                <div className="cmn-btn">
                  <Link onClick={fetchDataAndExportToExcel}>DOWNLOAD</Link>
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <hr />
        <Container fluid>
          <div className="product-tab">
            <ul>
              <li>
                <Link to="/UserVerification" className="active-tab">
                  ALL
                </Link>
              </li>
            </ul>
          </div>
        </Container>
      </div>
      <Container fluid>
        <div className="results-sec">
          <Row>
            <Col lg={6} className="d-flex align-items-center">
              <div className="show-results">
                {" "}
                Showing {1 + (page - 1) * limit} -{" "}
                {data?.data?.users?.length + (page - 1) * limit} of{" "}
                {data?.data?.totalCount} results
              </div>
            </Col>
            <Col lg={6}>
              <div className="select-result d-flex align-items-center justify-content-end">
                <span>Results per page</span>{" "}
                <Form.Select
                  onChange={(e) => setlimit(e.target.value)}
                  aria-label="Default select example"
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Container fluid className="px-0">
        <div class="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Profile Image </th>
                <th>Profile Name</th>
                <th>Email</th>
                {/* <th>Profile Image</th> */}
                {/* <th>Position</th> */}
                {/* <th>Location</th>
                <th>Status</th> */}
                <th>Location</th>
                <th>Profile Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.users?.map((user, index) => {
                const serialNumber = (page - 1) * limit + index + 1;
                return (
                  <tr>
                    <td>{serialNumber}</td>
                    <td className="user-img">
                      <img
                        src={
                          user?.profile_image
                            ? `${BASE_URL}${user?.profile_image}`
                            : logo
                        }
                        alt="user"
                      />
                    </td>

                    <td>
                      {" "}
                      <Link to={`/WorkersProfile/${user?._id}`}>
                        <b> {user?.full_name || "N/A"}</b>
                      </Link>
                    </td>
                    <td>{user?.email || "N/A"}</td>
                    {/* <td className="user-img">
                  <img src={require("../Assets/Images/user.png")} />  
                </td> */}
                <td> <div className="address-design">
                  {user?.address || "-"}</div></td>
                    <td>
                      <div className="select-box">
                        {/* <Form.Select
                          value={user?.is_admin_verified}
                          aria-label="Default select example"
                          onChange={(e) => {
                            dispatch(
                              verifyUser({
                                userId: user?._id,
                                type: e.target.value,
                              })
                            ).then((res) => {
                              if (res?.payload?.success) {
                                toast.success(res?.payload?.message);
                                setflag(!flag);
                              } else {
                                toast.error(res?.payload?.message);
                              }
                            });
                          }}
                        >
                          <option value="">Status</option>
                          <option value="2">Reject</option>
                          <option value="1">Verify</option>
                        </Form.Select> */}
                          <Form.Select
                          value={user?.is_admin_verified || ""}
                          aria-label="Default select example"
                          onChange={(e) => {
                            if (e.target.value === "1" || e.target.value === "2") {
                              setSelectedUserId(user?._id);
                              setSelectedAction(e.target.value);
                              setShowModal(true);
                            }
                          }}
                        >
                          <option value="">Status</option>
                          <option value="2">Reject</option>
                          <option value="1">Verify</option>
                        </Form.Select>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          {data?.data?.users?.length == 0 && (
            <div className="no-data-updated">
              <p className="no-data">No data available yet</p>
            </div>
          )}
        </div>
      </Container>
      <Pagination
        totalstuff={data?.data?.totalPages}
        limit={data?.data?.limit}
        setpages={setpage}
        search={search}
      />

      <Modal show={showModal} className="delete-popup">
        <Modal.Body>
          <h2 className="are-sure-text">
            Are you sure you want to {selectedAction === "1" ? "verify" : "reject"} this account?
          </h2>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-none">
          <Button className="theme-btn" onClick={handleVerifyAction}>
            Yes
          </Button>
          <Button
            className="theme-btn"
            onClick={() => {
              setShowModal(false);
              setSelectedUserId(null);
              setSelectedAction("");
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

    </Layout>
  );
}
